// Helpers puros de la app instalable (PWA). Sin dependencias del DOM real para
// poder testearlos: reciben navigator / window como parámetros.

export const INSTALL_DISMISS_KEY = 'planilla.installBanner.dismissedAt';
export const INSTALL_DISMISS_DAYS = 30;

// iPhone / iPad. Los iPad con iPadOS 13+ se presentan como "Macintosh" pero con
// pantalla táctil.
export const isIosDevice = (nav) => {
    if (!nav) return false;
    const ua = nav.userAgent || '';
    if (/iPad|iPhone|iPod/.test(ua)) return true;
    return /Macintosh/.test(ua) && (nav.maxTouchPoints || 0) > 1;
};

// En iOS solo Safari permite "Agregar a pantalla de inicio" como app. Chrome,
// Firefox y Edge de iOS agregan su marca al user agent (CriOS, FxiOS, EdgiOS).
export const isIosSafari = (nav) => {
    if (!isIosDevice(nav)) return false;
    return !/CriOS|FxiOS|EdgiOS|OPiOS|GSA\//.test(nav.userAgent || '');
};

// La app ya corre instalada (abierta desde el ícono, sin barra del navegador).
export const isStandaloneDisplay = (win) => {
    if (!win) return false;
    if (win.navigator && win.navigator.standalone === true) return true;
    if (typeof win.matchMedia !== 'function') return false;
    return win.matchMedia('(display-mode: standalone)').matches
        || win.matchMedia('(display-mode: minimal-ui)').matches;
};

// El aviso descartado vuelve a aparecer pasado INSTALL_DISMISS_DAYS.
export const isInstallDismissed = (dismissedAt, now = Date.now()) => {
    const timestamp = Number(dismissedAt);
    if (!Number.isFinite(timestamp) || timestamp <= 0) return false;
    return now - timestamp < INSTALL_DISMISS_DAYS * 24 * 60 * 60 * 1000;
};

// localStorage puede no estar disponible (navegación privada, datos bloqueados).
export const readStorage = (key) => {
    try {
        return window.localStorage.getItem(key);
    } catch (error) {
        return null;
    }
};

export const writeStorage = (key, value) => {
    try {
        window.localStorage.setItem(key, value);
    } catch (error) {
        // Sin almacenamiento el aviso vuelve a mostrarse la próxima vez: no es grave.
    }
};
